export const HTTP_CODES = {
  BAD_REQUEST: 400,
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
};

export type FetchStatus = 'idle' | 'loading' | 'success' | 'error';

export const clearBookmarkParam = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('bookmark');
  window.history.replaceState({}, document.title, url.toString());
};
